/* PS — En-tête collection : comportement du sélecteur, du repli et de la recherche.
   Lit ses paramètres dans les attributs data-* de chaque instance. */
(function(){
  'use strict';

  function initOne(root){
    if(!root || root.dataset.pseInit === '1'){ return; }
    root.dataset.pseInit = '1';

    var searchUrl  = root.getAttribute('data-search')   || '/search';
    var suggestUrl = root.getAttribute('data-suggest')  || '/search/suggest';
    var fallback   = root.getAttribute('data-fallback') || searchUrl;

    /* ---- Repli du texte d'introduction ---- */
    var intro  = root.querySelector('[data-pse-intro]');
    var toggle = root.querySelector('[data-pse-toggle]');
    if(intro && toggle){
      var txt = toggle.querySelector('[data-pse-toggle-txt]');
      var measure = function(){
        if(intro.classList.contains('is-open')){ return; }
        if(intro.scrollHeight <= intro.clientHeight + 4){
          toggle.style.display = 'none';
          intro.classList.remove('is-clamped');
        }
      };
      if(document.fonts && document.fonts.ready){
        document.fonts.ready.then(measure);
      } else {
        window.addEventListener('load', measure);
      }
      measure();
      toggle.addEventListener('click', function(){
        var open = intro.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if(txt){ txt.textContent = open ? toggle.dataset.less : toggle.dataset.more; }
      });
    }

    /* ---- Recherche par référence ---- */
    var refIn = root.querySelector('[data-pse-ref]');
    var refGo = root.querySelector('[data-pse-ref-go]');
    if(refIn && refGo){
      var norm = function(s){
        return (s || '').toString().toLowerCase().replace(/[^a-z0-9]/g, '');
      };

      var runRef = function(){
        var v = (refIn.value || '').trim();
        if(!v){ refIn.focus(); return; }

        var sep = searchUrl.indexOf('?') > -1 ? '&' : '?';
        var listUrl = searchUrl + sep + 'q=' + encodeURIComponent(v) + '&type=product&options%5Bprefix%5D=last';

        var settled = false;
        var goList = function(){
          if(settled){ return; }
          settled = true;
          window.location.href = listUrl;
        };

        if(!window.fetch){ goList(); return; }

        refGo.classList.add('is-busy');
        refGo.disabled = true;
        var timer = setTimeout(goList, 2500);

        fetch(suggestUrl + '.json?q=' + encodeURIComponent(v)
              + '&resources[type]=product&resources[limit]=5'
              + '&resources[options][unavailable_products]=last', { headers: { 'Accept': 'application/json' } })
          .then(function(res){ return res.ok ? res.json() : null; })
          .then(function(data){
            clearTimeout(timer);
            if(settled){ return; }
            var list = [];
            try { list = data.resources.results.products || []; } catch(e){ list = []; }

            if(list.length === 1){
              settled = true;
              window.location.href = list[0].url;
              return;
            }

            if(list.length > 1){
              var needle = norm(v);
              var exact = list.filter(function(p){
                if(norm(p.title).indexOf(needle) > -1){ return true; }
                if(p.sku && norm(p.sku).indexOf(needle) > -1){ return true; }
                return false;
              });
              if(exact.length === 1){
                settled = true;
                window.location.href = exact[0].url;
                return;
              }
            }

            goList();
          })
          .catch(function(){
            clearTimeout(timer);
            goList();
          });
      };

      refGo.addEventListener('click', runRef);
      refIn.addEventListener('keydown', function(e){
        if(e.key === 'Enter' || e.keyCode === 13){ e.preventDefault(); runRef(); }
      });
    }

    /* ---- Sélecteur en 3 étapes ---- */
    var selM = root.querySelector('[data-pse="m"]');
    var selT = root.querySelector('[data-pse="t"]');
    var selR = root.querySelector('[data-pse="r"]');
    var go   = root.querySelector('[data-pse-go]');
    var clr  = root.querySelector('[data-pse-clear]');
    var hint = root.querySelector('[data-pse-hint]');
    if(!selM || !selT || !selR || !go || !clr || !hint){ return; }

    var DATA = [];
    var dataEl = root.querySelector('[data-pse-data]');
    if(dataEl){ try { DATA = JSON.parse(dataEl.textContent) || []; } catch(e){ DATA = []; } }

    var CATS = {};
    var catsEl = root.querySelector('[data-pse-cats]');
    if(catsEl){ try { CATS = JSON.parse(catsEl.textContent) || {}; } catch(e){ CATS = {}; } }

    var MSG = {
      start: root.getAttribute('data-msg-start') || '',
      mid:   root.getAttribute('data-msg-mid')   || '',
      last:  root.getAttribute('data-msg-last')  || '',
      ready: root.getAttribute('data-msg-ready') || ''
    };

    function uniq(list){
      var seen = {}, res = [];
      list.forEach(function(v){ if(v && !seen[v]){ seen[v] = 1; res.push(v); } });
      return res;
    }

    /* Compte le nombre de produits distincts derrière chaque valeur d'une étape.
       Sert à afficher « Portail battant (16) » dans les menus : le client sait
       immédiatement combien de références l'attendent et évite les impasses. */
    function countBy(key, fn){
      var res = {};
      DATA.filter(fn || function(){ return true; }).forEach(function(x){
        var v = x[key];
        if(v){ res[v] = (res[v] || 0) + 1; }
      });
      return res;
    }

    function fill(sel, values, counts){
      var ph = sel.options[0] ? sel.options[0].textContent : '';
      sel.innerHTML = '';
      var z = document.createElement('option');
      z.value = ''; z.textContent = ph;
      sel.appendChild(z);
      values.forEach(function(v){
        var o = document.createElement('option');
        o.value = v;
        var n = counts ? counts[v] : 0;
        o.textContent = (n && n > 1) ? (v + '  (' + n + ')') : v;
        sel.appendChild(o);
      });
      sel.disabled = values.length === 0;
      sel.value = '';
    }

    function pluck(key, fn){
      return uniq(DATA.filter(fn || function(){ return true; }).map(function(x){ return x[key]; }));
    }

    function wrap(k){ return root.querySelector('[data-pse-wrap="' + k + '"]'); }

    function catUrl(m){
      if(!m){ return null; }
      var key = m.toString().toUpperCase().trim();
      if(CATS[key]){ return CATS[key]; }
      var found = null;
      Object.keys(CATS).forEach(function(k){
        if(found){ return; }
        if(k.indexOf(key) === 0 || key.indexOf(k) === 0){ found = CATS[k]; }
      });
      return found;
    }

    function refresh(){
      go.disabled = !selM.value;
      clr.classList.toggle('is-on', !!selM.value);
      wrap('t').classList.toggle('is-off', selT.disabled);
      wrap('r').classList.toggle('is-off', selR.disabled);
      if(!selM.value){ hint.textContent = MSG.start; }
      else if(!selT.value){ hint.textContent = MSG.mid.replace('%s', selM.value); }
      else if(!selR.value){ hint.textContent = MSG.last; }
      else { hint.textContent = MSG.ready; }
    }

    function searchFor(){
      var q = [selM.value, selT.value, selR.value].filter(Boolean).join(' ');
      var base = fallback || searchUrl;
      return base + (base.indexOf('?') > -1 ? '&' : '?') + 'q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
    }

    function resolve(){
      var m = selM.value, t = selT.value, r = selR.value, hit, matches, cat;

      if(m && t && r){
        hit = DATA.filter(function(x){ return x.m===m && x.t===t && x.r===r && x.u; })[0];
        if(hit) return hit.u;
      }

      if(m && t){
        matches = DATA.filter(function(x){ return x.m===m && x.t===t && x.u; });
        if(matches.length === 1) return matches[0].u;
        if(matches.length > 1) return searchFor();
      }

      if(m && !t){
        cat = catUrl(m);
        if(cat) return cat;
        matches = DATA.filter(function(x){ return x.m===m && x.u; });
        if(matches.length === 1) return matches[0].u;
      }

      return searchFor();
    }

    fill(selM, pluck('m'), countBy('m'));

    selM.addEventListener('change', function(){
      var m = selM.value;
      var byM = function(x){ return x.m === m; };
      fill(selT, m ? pluck('t', byM) : [], m ? countBy('t', byM) : null);
      fill(selR, [], null);
      refresh();
    });

    selT.addEventListener('change', function(){
      var m = selM.value, t = selT.value;
      var byMT = function(x){ return x.m===m && x.t===t; };
      fill(selR, t ? pluck('r', byMT) : [], t ? countBy('r', byMT) : null);
      refresh();
    });

    selR.addEventListener('change', refresh);

    clr.addEventListener('click', function(){
      selM.value = '';
      fill(selT, [], null); fill(selR, [], null);
      refresh();
      selM.focus();
    });

    go.addEventListener('click', function(){
      if(!selM.value){ return; }
      window.location.href = resolve();
    });

    refresh();
  }

  function initAll(){
    var nodes = document.querySelectorAll('[data-pse-root]');
    for(var i = 0; i < nodes.length; i++){ initOne(nodes[i]); }
  }

  /* Un seul écouteur global ferme les panneaux d'aide ouverts, quelle que soit
     le nombre d'instances présentes sur la page. */
  document.addEventListener('click', function(e){
    var open = document.querySelectorAll('.pse__help[open]');
    for(var i = 0; i < open.length; i++){
      if(!open[i].contains(e.target)){ open[i].open = false; }
    }
  });

  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape'){ return; }
    var open = document.querySelectorAll('.pse__help[open]');
    for(var i = 0; i < open.length; i++){ open[i].open = false; }
  });

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Réinitialisation après un rendu de section dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('[data-pse-root]');
    if(el){ initOne(el); }
  });
})();
